import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';

const FilterForm = ({
  show,
  toggle,
  months,
  members,
  fetchTransactions,
  showInfoMonth,
  showInfoCreatedBy,
}) => {
  const { trackerId } = JSON.parse(localStorage.getItem('user'));

  const [type, setType] = useState('all');
  const [createdBy, setCreatedBy] = useState('all');
  const [month, setMonth] = useState(months.optionValues[0]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(
        `https://api.dcsoft.ro/ext/api/transactions/filters/${trackerId}/${type}/${createdBy}/${month}`
      );
      if (!res.ok)
        throw new Error(
          `Error filtering data: ${res.status} - ${res.statusText}`
        );
      fetchTransactions(trackerId, type, createdBy, month);
      showInfoMonth(+month);
      showInfoCreatedBy(createdBy);
      toggle();
    } catch (error) {
      toast.error('Eroare filtrare tranzactii!');
      console.log(error.message);
    }
  };

  return (
    <form
      className={show ? 'filter-form' : 'filter-form close'}
      onSubmit={handleSubmit}
    >
      <h3>
        Filtreaza tranzactiile
        <FontAwesomeIcon
          icon={faCircleXmark}
          className="close-icon"
          onClick={() => toggle()}
        />
      </h3>
      <div className="form-control">
        <label>Tip</label>
        <select value={type} onChange={(e) => setType(e.target.value)}>
          <option value="all">Toate tipurile</option>
          <option value="expense">Cheltuieli</option>
          <option value="income">Venituri</option>
        </select>
      </div>
      <div className="form-control">
        <label>Membri</label>
        <select
          value={createdBy}
          onChange={(e) => setCreatedBy(e.target.value)}
        >
          {members.length > 1 && <option value="all">Toti membrii</option>}
          {members.map((member, index) => (
            <option key={index} value={member}>
              {member}
            </option>
          ))}
        </select>
      </div>
      <div className="form-control">
        <label>Luna</label>
        <select value={month} onChange={(e) => setMonth(e.target.value)}>
          {months.optionValues.map((optionValue, index) => (
            <option key={index} value={optionValue}>
              {months.optionTexts[index]}
            </option>
          ))}
        </select>
      </div>
      <input
        type="submit"
        className="btn filter-btn"
        value="Filtreaza tranzactiile"
      />
    </form>
  );
};

export default FilterForm;
